import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { numberWithCommas } from "../../../utilities/commonFunctions/formattingFunctions";

const EpaViolationCntsTbl = ({ data }) => {
  const columns = [
    {
      Header: "Violation Type",
      accessor: "violationType"
    },
    {
      Header: "Individual Violation",
      accessor: "individualViolation"
    },
    {
      Header: "Systems",
      accessor: "system"
    },
    {
      Header: "Total Population",
      accessor: (d) => {
        return d.totalPopulation ? numberWithCommas(d.totalPopulation) : "";
      }
    },
    {
      Header: "Each Instance Population",
      accessor: (d) => {
        return d.eachInstancePopulation ? numberWithCommas(d.eachInstancePopulation) : "";
      }
    }
  ];

  useEffect(() => {
    if (data && data.length) console.log("DATA: ", data);
  }, [data]);

  return (
    <>
      <Row>
        <Col>
          <h3>EPA Health Violation Counts</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          {data.length > 0 ? (
            <DtsReactTable data={data} columns={columns} headerColor='ddw' cypressid='epaHealthVioCntsTbl' />
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <span>
            <sup className='m-2' cypressid='totalPopDef'>
              <b>Total Population:</b> is the population within a water system that is affected by a violation.{" "}
            </sup>
            <sup className='m-2' cypressid='instancePopDef'>
              <b>Instance Population:</b> the population affected by a violation regardless of the system id.{" "}
            </sup>
          </span>
        </Col>
      </Row>
    </>
  );
};

export default EpaViolationCntsTbl;
